import React, { useState, useContext } from 'react';
import { Redirect } from 'react-router';
import { Container, CssBaseline } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Textfield from 'components/FormsUI/TextfieldGeneral';
import AirportsService from '../services/airports.servicse';
import AuthContext from 'store/AuthContext';
import AppButton from 'components/FormsUI/AppButton/appButton';
import ToastContext from 'store/ToastContext';

import govSemel from '../images/Emblem_of_Israel.svg';
import PopLogo from '../images/popImmigrationIconOnly.png';

const useStyles = makeStyles((theme) => ({
    header: {
        display: 'flex',
        flexDirection: 'column'
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    submit: {
    },
}));

function Mfa(props) {
    const ctx = useContext(AuthContext);
    const { openToast } = useContext(ToastContext);
    const [cognitoUser, setCognitoUser] = useState(props.location.congnitoUser);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const classes = useStyles();


    if (!cognitoUser || !cognitoUser.username) {
        return <Redirect to="/" />;
    }

    const handleSubmit = async (values) => {
        setSubmitLoading(true);
        setErrorMessage("");
        ctx.mfaChallenge(cognitoUser, values.securityCode).then(user => {
            if (user.role === "admin" || user.role === "user") {
                AirportsService.getAirportsOptions().then(data => { }); // preload airports
                props.history.push({
                    pathname: `/HomePage`
                });
            } else if ((user.role === "" || user.role === undefined) && user.error === undefined) {
                props.history.push({
                    pathname: '/AdministratorManagement/'
                });
            }
        }).catch(err => {
            setSubmitLoading(false);
            setErrorMessage(err)
        })
    }

    const codeChangeHandler = (val = '') => {
        setErrorMessage('')
    } 

    const resendSecurityCode = async () => {
        setErrorMessage("");
        setResendLoading(true);
        await ctx.signOut();
        ctx.signIn(cognitoUser.username).then(cogUser => {
            setCognitoUser(cogUser);
            setResendLoading(false);
            openToast("Code was sent successfully", "success");
        }
        ).catch(err => {
            setErrorMessage(err.message);
            setResendLoading(false);
            openToast("Error while sending code", "error");
        })
    }

    return (
        <Container component="main" maxWidth="xs" className="frame">
            <CssBaseline />
            <div style={{ padding: "48px 40px 20px" }}>
                <div className={classes.header}>
                    <div><span className="pull-left" style={{ float: "left" }}><img src={govSemel} height="50" alt="gov"/>
                    </span>
                        <span className="pull-right" style={{ float: "right" }}><img src={PopLogo} height="50" alt="logo"/></span>
                    </div>
                </div>
                <div className="paper">
                    <h1>Welcome</h1>
                    <div>
                        <h6>
                            {cognitoUser.username}</h6>
                    </div>
                    <div>
                        <Formik
                            initialValues={{ securityCode: '' }}
                            validateOnBlur={false}
                            validateOnChange={false}
                            onSubmit={(values, { setSubmitting }) => {
                                setSubmitting(true);
                                handleSubmit(values);
                            }}
                            validationSchema={Yup.object().shape({
                                securityCode: Yup.string()
                                    .required('Security code is required'),
                            })}>
                            {(props) => {
                                const {
                                    handleSubmit,
                                } = props;
                                return (
                                    <form onSubmit={handleSubmit}>
                                        <Textfield 
                                            name="securityCode" 
                                            label="Enter your security code" 
                                            onChange={codeChangeHandler} 
                                            type="search"
                                            margin="normal"
                                            autoFocus={true}
                                            FormHelperTextProps={{classes: { error: "validation-message" } }}
                                            ></Textfield>
                                        <div className="mb-1" style={{minHeight: 31}}>
                                            {errorMessage && <div className="alert alert-danger p-1">{errorMessage}</div>}
                                        </div>

                                        <div className='row'>
                                            <div className='col-7' style={{paddingRight: 0}}>
                                                <AppButton id="mfaResendBtn" label="RESEND SECURITY CODE" color="secondary" action={resendSecurityCode} disabled={submitLoading} isBlock={true}
                                                isLoading={resendLoading}>
                                                </AppButton>
                                            </div>
                                            <div className='col-5'>
                                                <AppButton type="submit" id="mfaSubmitBtn" label="Login" isLoading={submitLoading} disabled={resendLoading}
                                                    isBlock={true}>
                                                </AppButton>
                                            </div>
                                        </div>
                                    </form>
                                )
                            }}
                        </Formik>
                    </div>
                </div>
            </div >
        </Container >
    );
};

export default Mfa;
